/**
 * In the sidebar, during a trial: how many days are left, quietly ("Trial · 12 days left"). For admins it leads to the
 * Plan page; for everyone else it only says so. The banner atop the pages speaks up only in the trial's last days
 * (`planNotices`).
 */
import type { SpaceOut } from "../api/types.gen.ts";
import { t } from "../i18n/index.ts";
import { spaceUrl } from "../lib/paths.ts";
import { atLeast } from "../lib/roles.ts";
import { trialDaysLeft } from "../lib/standing.ts";
import { Link } from "../ui/Button.tsx";
import { FOCUS } from "../ui/styles.ts";

const CHIP =
  "inline-flex items-center rounded-full border border-zinc-200 bg-white px-2.5 py-0.5 text-xs text-zinc-600";

export function TrialChip({ space, onNavigate }: { space: SpaceOut; onNavigate?: () => void }) {
  const st = space.standing;
  if (st.state !== "trial" || !st.trial_ends_at) {
    return null;
  }
  const text = t("plan.trialLeft", { count: trialDaysLeft(st.trial_ends_at) });
  return (
    <div class="mb-3 px-3">
      {atLeast(space.role, "admin") ? (
        <Link
          href={spaceUrl(space, "/settings/billing")}
          class={`${CHIP} ${FOCUS} hover:border-zinc-300 hover:text-zinc-900`}
          onClick={onNavigate}
        >
          {text}
        </Link>
      ) : (
        <span class={CHIP}>{text}</span>
      )}
    </div>
  );
}
